import FeaturedEvent from '~/components/HCP/FeaturedEvent/FeaturedEvent';
import LinkList from '~/components/HCP/LinkList/LinkList';
import LogoList from '~/components/HCP/LogoList/LogoList';
import ProductCTA from '~/components/HCP/ProductCTA/ProductCTA';
import {
  ContentCtaItem,
  FeaturedEventItem,
  LinkListItem,
  LogoListItem,
} from '~/mappers/header/models';

export type SubmenuType =
  | LogoListItem
  | FeaturedEventItem
  | LinkListItem
  | ContentCtaItem;

export enum SUBMENU_TYPE_NAME {
  LOGO_LIST = 'Contentstack_header_logo_list',
  CONTENT_CTA = 'Contentstack_header_content_cta',
  FEATURED_EVENT = 'Contentstack_header_featured_event',
  LINK_LIST = 'Contentstack_header_link_list',
}

export const submenuComponentType: Record<
  SUBMENU_TYPE_NAME,
  React.ComponentType<any>
> = {
  [SUBMENU_TYPE_NAME.LOGO_LIST]: LogoList,
  [SUBMENU_TYPE_NAME.CONTENT_CTA]: ProductCTA,
  [SUBMENU_TYPE_NAME.FEATURED_EVENT]: FeaturedEvent,
  [SUBMENU_TYPE_NAME.LINK_LIST]: LinkList,
};

export const identityEmpty = () => ({});

export const toBool = (v: unknown) =>
  v === true || v === 'true' || v === 1 || v === '1';

export const logoListPropsMapper = (submenuItem) => {
  const nodes = Array.isArray(submenuItem?.items) ? submenuItem.items : [];

  const items = nodes.map((item) => {
    const link = item?.item[0];

    return {
      imgSrc: item?.logo?.image?.url,
      url: link?.url,
      alt: '',
      brandTitle: item.brand_title,
    };
  });

  return {
    heading: submenuItem?.heading,
    isDivider: toBool(submenuItem?.divider),
    items,
  };
};

export const contentCtaPropsMapper = (submenuItem) => {
  const btn = submenuItem?.button ?? {};

  return {
    heading: submenuItem?.heading ?? '',
    description: submenuItem?.description ?? '',
    url: btn.link[0].url,
    ctaLabel: btn?.title || '',
  };
};

export const featuredEventPropsMapper = (submenuItem) => {
  const entry = Array.isArray(submenuItem?.item)
    ? submenuItem.item[0]
    : undefined;

  const { url } = entry;

  const title = entry?.page_header?.heading_block?.headline ?? '';

  const description: string = entry?.event_data?.event_description ?? '';

  const imgSrc: string =
    entry?.listing_image[0]?.image?.url ??
    entry?.event_image?.image?.url ??
    entry?.page_header?.image_element?.[0]?.image?.url ??
    '';

  const imgAlt: string = entry?.event_image?.alt ?? '';

  return {
    heading: submenuItem?.heading,
    linkLabel: submenuItem?.link_label,
    isDivider: submenuItem?.divider,
    title,
    description,
    url,
    imgSrc,
    imgAlt,
  };
};

export const linkListPropsMapper = (submenuItem) => {
  const iconUrl = submenuItem?.icon?.image?.url ?? '';

  const links = submenuItem.links.map((item) => ({
    title: item?.title,
    url: item?.link[0]?.url,
    ariaLabel: item?.link[0]?.aria_label,
  }));

  return {
    heading: submenuItem?.heading,
    iconStc: iconUrl || undefined,
    columnsNumber: submenuItem?.columns_number,
    isDivider: toBool(submenuItem?.divider),
    links,
  };
};
export const componentPropsMapper = {
  [SUBMENU_TYPE_NAME.LOGO_LIST]: logoListPropsMapper,
  [SUBMENU_TYPE_NAME.CONTENT_CTA]: contentCtaPropsMapper,
  [SUBMENU_TYPE_NAME.FEATURED_EVENT]: featuredEventPropsMapper,
  [SUBMENU_TYPE_NAME.LINK_LIST]: linkListPropsMapper,
};

export type LayoutKey = '1' | '1-1' | '2-1' | '1-2' | '1-1-1';

export const layoutClassNameMapping: Record<LayoutKey, string> = {
  '1': 'layout-1',
  '1-1': 'layout-1-1',
  '2-1': 'layout-2-1',
  '1-2': 'layout-1-2',
  '1-1-1': 'layout-1-1-1',
};
